import React from 'react';
import i18n from 'helpers/i18n';
import messages from './messages';
import { Button } from '@teachstonellc/component-library';
import { Download } from '@teachstonellc/component-library/dist/icons';
import { TRAINING_STATUS } from 'types/api/Training';
import { Container, Status } from './Styled';

interface TrainingStatusProps {
  /** The training status. */
  status: TRAINING_STATUS;

  /** The training ID. */
  trainingId: number;

  /** The training name. */
  trainingName: string;

  /** If `true` a link to download the certificate is displayed */
  certificate?: boolean;
}

const TrainingStatus: React.FC<TrainingStatusProps> = ({
  status,
  trainingId,
  trainingName,
  certificate
}) => {
  function getColor(status: TRAINING_STATUS) {
    if (status === 'active') {
      return '#fbbd08';
    } else if (status === 'completed') {
      return '#107a6a';
    } else if (status === 'canceled') {
      return '#b5324b';
    }
  }

  function handleDownload(e: React.MouseEvent<HTMLSpanElement, MouseEvent>) {
    e.preventDefault();
    window.open(`/api/v2/trainings/${trainingId}/certificate`, '_blank');
  }

  return (
    <Container>
      <Status>
        <i
          aria-hidden="true"
          className="fa-solid fa-circle mr-1"
          style={{ color: getColor(status) }}
        />
        {i18n.ft(messages[status])}
      </Status>
      {status === 'completed' && certificate && (
        <React.Fragment>
          <Button
            variant="aux"
            shape="rounded"
            size="small"
            onClick={handleDownload}
            startIcon={Download}
            aria-label={i18n.ft(messages.downloadAriaLabel, {
              name: trainingName
            })}
          >
            {i18n.ft(messages.download)}
          </Button>
        </React.Fragment>
      )}
    </Container>
  );
};

export default TrainingStatus;
